var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNeutralClimate(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59701 16.8844C4.52678 15.4808 3.16473 13.1166 3.16473 10.4425C3.16545 6.14594 6.67956 2.65008 10.9996 2.65008C11.5963 2.65008 12.1763 2.71917 12.7353 2.84498L13.8113 0.382531C12.9156 0.135995 11.9735 0 10.9996 0C5.21034 0 0.5 4.68491 0.5 10.4425C0.5 14.2045 2.51158 17.5077 5.52099 19.3462L6.59701 16.8844Z",
    fill: "#3D6629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7701 10.4445C15.7701 13.0647 13.634 15.1898 10.999 15.1898C8.36464 15.1898 6.22852 13.0655 6.22852 10.4445C6.22852 7.8235 8.36464 5.69922 10.999 5.69922C13.6347 5.69995 15.7701 7.82423 15.7701 10.4445Z",
    fill: "#3D6629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.196 20.8801C16.8947 20.7761 21.5001 16.1356 21.5001 10.4427C21.5001 6.68068 19.4885 3.37754 16.4791 1.53906L15.4023 4.00078C17.4726 5.40509 18.8346 7.76864 18.8346 10.4427C18.8346 14.7393 15.3198 18.2351 10.9998 18.2351C10.4031 18.2351 9.82307 18.166 9.26478 18.0402L6.66016 23.9993H9.83249L11.196 20.8801Z",
    fill: "#3D6629"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralClimate);
export default __webpack_public_path__ + "static/media/neutral-climate.93bf131f.svg";
export { ForwardRef as ReactComponent };